import Url from "url-parse";

import config from "../../../config";
import { navigateToScene } from "../navigation";
import { hideAllModals } from "../../../lib/react-redux-modal-provider";
import { showModal } from "../../../lib/react-redux-modal-provider/events";
import { isInternalLink } from "../../../lib/isInternalLink";

const blockedPaymentPathParts = [
  "/payment-details/",
  "/plans/",
  "/offer-checkout/",
  "/skorzystaj-z-oferty/"
];

const blockedPaymentModalMessage =
  "Sorry, this link is only available in browser.";

const getOrigin = url => {
  if (!url || typeof url !== "string") {
    return null;
  }

  try {
    return new Url(url).origin?.toLowerCase?.() ?? null;
  } catch {
    return null;
  }
};

export const shouldBlockPaymentNavigation = url => {
  if (!config.blockPaymentLinksInApp) {
    return false;
  }

  if (!isInternalLink(url)) {
    return false;
  }

  let currentPathName = "";

  try {
    currentPathName = new Url(url).pathname ?? "";
  } catch {
    currentPathName = "";
  }

  return blockedPaymentPathParts.some(pathPart =>
    currentPathName.includes(pathPart)
  );
};

export const showBlockedPaymentModal = () => {
  showModal("ConfirmModal", {
    skipShowIfAlreadyVisible: true,
    message: blockedPaymentModalMessage,
    decisionLabels: {
      cancel: "Ok",
      confirm: "See our plans"
    },
    cancel: () => {},
    confirm: () => {
      hideAllModals();
      navigateToScene("plans");
    }
  });
};
